import api from './api';

/**
 * Questionari somministrati al paziente.
 *
 * L'invio delle risposte NON e' qui: parte dal tablet, che non ha un
 * utente collegato e usa la chiave del dispositivo (/api/firma-tablet).
 */
export const questionariAPI = {
    elenco: (area) => api.get('/questionari', { params: area ? { area } : {} }),
    perPaziente: (pazienteId) => api.get(`/questionari/paziente/${pazienteId}`),
    dettaglio: (id) => api.get(`/questionari/compilazione/${id}`),
    invia: (pazienteId, questionarioId, dispositivoId) =>
        api.post(`/questionari/paziente/${pazienteId}/invia`, {
            questionario_id: questionarioId,
            dispositivo_id: dispositivoId,
        }),
    annulla: (id, motivo) => api.post(`/questionari/compilazione/${id}/annulla`, { motivo }),

    /* Compilazione alla postazione, per chi il tablet non lo usa.
       `apri` riprende quella gia' in corso se c'e', invece di crearne una
       seconda: un questionario da 84 item interrotto non si ricomincia. */
    apri: (pazienteId, questionarioId) =>
        api.post(`/questionari/paziente/${pazienteId}/apri`, { questionario_id: questionarioId }),
    salva: (id, risposte, concludi = false) =>
        api.post(`/questionari/compilazione/${id}/risposte`, { risposte, concludi }),

    // Le postazioni servono per scegliere dove mandarlo
    dispositivi: () => api.get('/firma-tablet/dispositivi'),
};

export default questionariAPI;
